/**
 * Runtime info API endpoint — T20.
 * Maps PRD §9.9 / K1 to typed fetch calls via apiClient.
 */
import { apiClient } from '../client';

export const runtimeInfoApi = {
  get() {
    return apiClient.request('GET', '/api/runtime-info');
  },
};
